import React from "react";
import { Link } from "react-router-dom";

// Assets
// import image1 from "../assets/Chaney ID.jpeg";
// import image2 from "../assets/Chelsea ID.jpeg";
// import image3 from "../assets/Courtney ID.jpeg";
// import image4 from "../assets/ID picture.jpeg";
// import image5 from "../assets/Stacey ID.png";

const teamDetails = [
  {
    name: "Chaney Pietersen",
    role: "Founder | CEO",
    bio: "Chaney Pietersen is a visionary entrepreneur, Founder and CEO of Branding and Events Studio, where creativity meets strategy and purpose drives execution. With a Degree in Public Management and currently completing her Master’s degree focusing on female entrepreneurship, Chaney is deeply committed to transforming the entrepreneurial landscape for young women. \n\nBacked by over 3 years of leadership experience and over 10 years within Education sector, she combines strategic management expertise with a heart for mentorship and empowerment. Chaney doesn’t just build brands — she builds platforms for growth, impact, and legacy. \n\nHer mission is to develop confident female entrepreneurs who identify market gaps, innovate boldly, and serve their communities with excellence",
    // image: image1,
    expertise: ["Strategic Leadership", "Female Entrepreneurship", "Business Mentorship"]
  },
  {
    name: "Chelsea Kolkoto",
    role: "Co-Founder | Brand Director | Social Strategy & Creative Lead",
    bio: "Chelsea Kolkoto serves as the Brand Director at Branding and Events Studio, where she leads the company’s visual identity, digital presence, and creative direction. She holds a Bachelor of Social Science, which equips her with a deep understanding of human behavior, communication patterns, audience engagement, and social dynamics. \n\nShe has also completed a Social Media Marketing Course, strengthening her expertise in digital strategy, platform algorithms, content optimization, and online brand positioning. This combined academic and practical training enables her to craft strategies that are both creative and performance-driven. With experience in data tracking and user engagement analysis, Chelsea specializes in: Monitoring social media performance metrics Analyzing audience behavior and engagement patterns Identifying what content is most attractive and impactful Using data-driven insights to refine brand strategy She manages the company’s social media platforms, ensuring a consistent, professional, and engaging brand presence. \n\nChelsea also conceptualizes and oversees creative campaigns designed to increase brand visibility and audience interaction. In addition, she leads the creative direction for promotional videos, working closely with clients to translate their vision into compelling visual content that strengthens their brand positioning.",
    // image: image2,
    expertise: ["Digital Strategy", "Visual Identity", "Content Optimization"]
  },
  {
    name: "Courtney Carelse",
    role: "Co-Founder | Events Director",
    bio: "Courtney Carelse is the Co-Founder and Events Director of Branding and Events Studio, where she leads the planning and execution of thoughtfully curated, high-impact events. \n\nWith experience in the hospitality sector, Courtney brings strong expertise in guest experience, client service, and operational coordination. Her background ensures that every event is structured, seamless, and professionally managed from concept to completion. She also holds an N4 Certificate in Early Childhood Development, with a focus on child health, day care personnel, education, and educare didactics. This qualification uniquely positions her to design and manage children’s events with safety, structure, and age-appropriate creativity at the forefront. \n\nHer experience in healthcare administration has further strengthened her organizational skills, attention to detail, and ability to perform efficiently in high-pressure environments. Courtney is known for building strong client and vendor relationships, ensuring that every event reflects excellence, intentional planning, and meaningful connection.",
    // image: image3,
    expertise: ["Logistics Management", "Vendor Sourcing", "Event Delivery"]
  },
  {
    name: "Teyana Raubenheimer",
    role: "IT Director | Application Development Specialist",
    bio: "Teyana Raubenheimer is the IT Director and technical architect behind Branding and Events Studio’s digital solutions. \n\nWith a Diploma in Applications Development and currently completing her Advanced Diploma Multimedia, she brings strong technical expertise and innovative thinking to the team. She has hands-on experience in building websites, developing mobile and web applications, and creating digital systems that are both functional and user-friendly. \n\nTeyana specializes in transforming ideas into seamless digital experiences that align with business goals.",
    // image: image4,
    expertise: ["Technical Architecture", "Web Development", "UI/UX Systems"]
  },
  {
    name: "Anastacia Pienaar",
    role: "Public Relations Officer | Recruitment & Communications Lead",
    bio: "Anastacia Pienaar serves as the Public Relations Officer at Branding and Events Studio, where she is responsible for managing external communications, stakeholder relationships, and brand reputation. \n\nWith two years of experience as a Call Centre Agent, Anastacia developed strong communication, client engagement, and conflict-resolution skills. Her ability to handle diverse personalities and manage client interactions professionally strengthens the company’s relationship-building approach. She further gained 1 year and 5 months of experience as a Recruiter, where she specialized in sourcing, screening, and placing candidates. This role enhanced her understanding of talent acquisition, organizational needs, and strategic workforce planning. \n\nAnastacia holds an AI for Leaders Certificate, equipping her with modern digital tools and strategic insights into how artificial intelligence can enhance communication and recruitment processes. She has also completed a LinkedIn Recruitment Certification, where she was trained to effectively utilize LinkedIn as a strategic platform for talent sourcing and professional networking.",
    // image: image5,
    expertise: ["Public Relations", "Customer Service", "Recruitment"]
  }
];

export default function TeamBiography() {
  return (
    <div className="bg-white min-h-screen pt-24 pb-32 overflow-x-hidden font-sans">
      
      {/* 🏛️ Editorial Header */}
      <header className="max-w-6xl mx-auto px-6 mb-32">
        <Link to="/our-team" className="text-[10px] uppercase tracking-[0.4em] text-neutral-400 hover:text-pink-400 transition-colors inline-block mb-12">
          ← The Collective
        </Link>
        <div className="max-w-4xl mx-auto text-center relative">
  {/* 🌸 Subtle Background Glow for Color Depth */}
  <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-gradient-to-tr from-teal-100/30 to-pink-100/30 blur-[80px] rounded-full pointer-events-none" />

  <div className="relative z-10">
    <h1 className="font-['Playfair_Display'] text-3xl md:text-5xl lg:text-7xl font-light text-neutral-900 leading-[1.1] mb-8">
     Vision behind the <br/>
      <span className="italic bg-gradient-to-r from-teal-400 to-pink-400 bg-clip-text text-transparent">
        Brand.
      </span>
    </h1>
    
    {/* Refined Underline with Brand Colors */}
    <div className="w-16 h-[2px] bg-gradient-to-r from-teal-200 to-pink-200 mx-auto mb-10 rounded-full" />

    <p className="text-neutral-400 text-xs md:text-sm font-medium tracking-[0.4em] uppercase">
      A deeper look at the specialists crafting your story.
    </p>
  </div>
</div>
      </header>

      {/* 👥 Biographies */}
      <div className="max-w-6xl mx-auto px-6 space-y-40">
        {teamDetails.map((member, index) => (
          <section 
            key={member.name}
            className={`flex flex-col lg:flex-row items-start gap-16 lg:gap-24 ${index % 2 !== 0 ? 'lg:flex-row-reverse' : ''}`}
          >
            {/* Image Side - Now smaller (2/5 ratio) */}
            {/* <div className="w-full lg:w-[38%] relative">
              <div className="aspect-[4/5] rounded-[2rem] overflow-hidden shadow-xl">
                <img 
                  src={member.image} 
                  alt={member.name} 
                  className="w-full h-full object-cover grayscale-[10%] hover:grayscale-0 transition-all duration-1000"
                />
              </div>
            </div> */}

            {/* Bio Side - More spacious (3/5 ratio) */}
            <div className="w-full lg:w-[100%] text-left pt-4">
              <div className="mb-10">
                <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl text-neutral-900 mb-3 tracking-wide">{member.name}</h2>
                <p className="text-[11px] uppercase tracking-[0.3em] text-pink-400 font-bold">{member.role}</p>
              </div>

              {/* Bio text with white-space preserved for line breaks */}
              <div className="text-neutral-500 font-light leading-relaxed text-base md:text-[17px] space-y-6 whitespace-pre-line">
                {member.bio}
              </div>

              {/* Skills Footer */}
              <div className="mt-12 pt-10 border-t border-neutral-100">
                <p className="text-[10px] uppercase tracking-[0.2em] text-neutral-300 font-bold mb-6">Expertise Focus</p>
                <div className="flex flex-wrap gap-3">
                  {member.expertise.map(skill => (
                    <span key={skill} className="text-[12px] text-neutral-700 italic border-r border-neutral-200 pr-4 last:border-none">
                      {skill}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </section>
        ))}
      </div>

      {/* ✉️ Minimal Call to Action */}
      <footer className="mt-40 text-center">
        <h3 className="font-['Playfair_Display'] text-3xl mb-8">Ready to bring your vision to life?</h3>
        <Link 
          to="/contact" 
          className="px-12 py-5 bg-neutral-900 text-white rounded-full text-xs uppercase tracking-[0.4em] hover:bg-pink-400 transition-all shadow-xl"
        >
          Book A Consultation
        </Link>
      </footer>
    </div>
  );
}
